// 题目类型
export const topicTypeArr = [
  { label: '单选题', value: 1 },
  { label: '多选题', value: 2 }
]

// 题目类型
export const topicTypeMap = {
  1: '单选题',
  2: '多选题'
}

// 查看题目类型
export const topicTypeViewMap = {
  1: '单选',
  2: '多选'
}
